module.exports = __webpack_public_path__ + "images/italic-button.631d55ad945527ceb76ce994ad7f8ac5.svg";